import React, { useState, useEffect } from 'react';
import MyText from "./MyText";

export default function Input({ title, initialValue, type, width, nRows, callback, pressCallback, obb }) {
    const [txt, setTxt] = useState(initialValue);

    useEffect(() => {
        setTxt(initialValue);
    }, [initialValue]);

    const handleChange = (event) => {
        let { value, rows } = event.target;
        if (rows <= 1 || value.length <= 50) {
            setTxt(value);
            if (callback) {
                callback(value);
            }
        }
    }

    return (
        <div style={styles.container}>
            <MyText style={styles.myText}>
                {title}{obb && <span style={{ color: 'red', fontSize: "0.6rem", verticalAlign: "super" }}>*</span>}
            </MyText>
            <input
                className='zSelect'
                type={type}
                value={txt}
                onChange={handleChange}
                autoComplete="off"
                style={{ ...styles.input, "width": width }}
                rows={nRows}
                onKeyUp={pressCallback}
            />
        </div>
    );
}
const styles = {
    container: {
        flex: 1,
        marginBottom: "1rem",
    },
    myText: {
        fontSize: '1rem',
        fontFamily: 'Como-Bold',
        marginBottom: '0.5rem',
        color: "#282d68"
    },
    input: {
        backgroundColor: 'white !important',
        color: 'black',
        padding: '8px 10px',
        boxSizing: 'border-box',
    }
}